<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12">
  <div class="card card-outline-danger">
      <div class="card-header">
        Missing Documentation
      </div>
      <div class="card-block">
        <ul>
          <li>Quality Objective document missing.  Click here for a template to get started.</li>
        </ul>
      </div>
      </div>
    </div>
  </div>
    <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <i class="fa fa-align-justify"></i> File Control
              <button type="button" class="btn btn-outline-primary pull-right"><i class="fa fa-plus"></i>&nbsp; New Document</button>
            </div>
            <div class="card-block">
              <table class="table table-bordered table-striped table-sm">
                <thead>
                  <tr>
                    <th>File Category</th>
                    <th>Document Type</th>
                    <th>Document Name</th>
                    <th>Load Date</th>
                    <th>Last Updated</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Quality Handbook</td>
                    <td>Scope Document</td>
                    <td>SPD Quality Manual (Scope)</td>
                    <td>3/1/2018</td>
                    <td>4/17/2018</td>
                    <td>
                      <span class="badge badge-success">Active</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Quality Handbook</td>
                    <td>Policy Document</td>
                    <td>SPD Quality Policy &amp; Objectives</td>
                    <td>3/1/2018</td>
                    <td>4/17/2018</td>
                    <td>
                      <span class="badge badge-success">Active</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Quality Handbook</td>
                    <td>Procedure Documentation</td>
                    <td>SPD Quality Management Procedure</td>
                    <td>3/1/2018</td>
                    <td>3/9/2018</td>
                    <td>
                      <span class="badge badge-success">Active</span>
                    </td>
                  </tr>
                  <tr>
                    <td>SPD - Decontamination</td>
                    <td>Policy Document</td>
                    <td>Vendor Management Policy</td>
                    <td>3/3/2018</td>
                    <td>4/15/2018</td>
                    <td>
                      <span class="badge badge-success">Active</span>
                    </td>
                  </tr>
                  <tr>
                    <td>SPD - Decontamination</td>
                    <td>Work Instructions</td>
                    <td>Vendor Drop Off Work Instructions</td>
                    <td>3/1/2018</td>
                    <td>4/17/2018</td>
                    <td>
                      <span class="badge badge-success">Active</span>
                    </td>
                  </tr>
                  <tr>
                    <td>SPD - Decontamination</td>
                    <td>Process Validation Policy</td>
                    <td>Vendor Process Measurement Policy</td>
                    <td>3/1/2018</td>
                    <td>4/17/2018</td>
                    <td>
                      <span class="badge badge-success">Active</span>
                    </td>
                  </tr>
                  <tr>
                    <td>SPD - Decontamination</td>
                    <td>Policy Document</td>
                    <td>Decontam. Receiving, Sorting &amp; Disassembly Policy</td>
                    <td>3/1/2018</td>
                    <td>4/17/2018</td>
                    <td>
                      <span class="badge badge-success">Active</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Quality Handbook</td>
                    <td>Scope</td>
                    <td>TBHC CS Department Scope</td>
                    <td>3/1/2018</td>
                    <td>4/17/2018</td>
                    <td>
                      <span class="badge badge-success">Active</span>
                    </td>
                  </tr>
                  <tr>
                    <td>SPD - Decontamination</td>
                    <td>Procedure Documentation</td>
                    <td>Decontam. Receiving, Sorting &amp; Disassembly Process</td>
                    <td>7/1/2017</td>
                    <td>3/1/2018</td>
                    <td>
                      <span class="badge badge-default">Inactive</span>
                    </td>
                  </tr>
                  <tr>
                    <td>SPD - Decontamination</td>
                    <td>Work Instructions</td>
                    <td>Decontam. Receiving, Sorting &amp; Disassembly Work Instructions</td>
                    <td>3/1/2018</td>
                    <td>4/17/2018</td>
                    <td>
                      <span class="badge badge-success">Active</span>
                    </td>
                  </tr>
                  <tr>
                    <td>SPD - Decontamination</td>
                    <td>Process Validation Form</td>
                    <td>Rinsing, Presoaking, Manual Cleaning</td>
                    <td>3/1/2018</td>
                    <td>4/17/2018</td>
                    <td>
                      <span class="badge badge-success">Active</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <nav>
                <ul class="pagination">
                  <li class="page-item"><a class="page-link" href="#">Prev</a></li>
                  <li class="page-item active">
                    <a class="page-link" href="#">1</a>
                  </li>
                  <li class="page-item"><a class="page-link" href="#">2</a></li>
                  <li class="page-item"><a class="page-link" href="#">3</a></li>
                  <li class="page-item"><a class="page-link" href="#">4</a></li>
                  <li class="page-item"><a class="page-link" href="#">Next</a></li>
                </ul>
              </nav>
            </div>
          </div>
        </div><!--/.col-->
      </div><!--/.row-->
  </div>
</template>

<script>
export default {
  name: 'document-control'
}
</script>
